export interface ExamDetails {
  id: string
  percentToPass: number
  timeLimitSeconds: number
}

export function defaultExamDetails(): ExamDetails {
  return { id: '', percentToPass: 0, timeLimitSeconds: 0 }
}

export interface ExamResult {
  passed: boolean
  score: {
    min: number
    max: number
    raw: number
    percent: number
  }
}

function defaultExamResult(): ExamResult {
  return { passed: false, score: { min: 0, max: 0, raw: 0, percent: 0} }
}

export class ExamStateData {
  private _examDetails: ExamDetails
  private _examResult: ExamResult
  private _remainingTimeSeconds = 0

  constructor(examDetails: ExamDetails) {
    this._examDetails = examDetails
    this._examResult = defaultExamResult()
    this._remainingTimeSeconds = examDetails.timeLimitSeconds
  }

  updateResult(result: ExamResult) {
    this._examResult = result
  }

  updateRemainingTimeSeconds(seconds: number) {
    this._remainingTimeSeconds = seconds
  }

  get examDetails() {
    return this._examDetails
  }

  get examResult() {
    return this._examResult
  }

  get hasTimeLimit() {
    return this._examDetails.timeLimitSeconds > 0
  }

  get remainingTimeSeconds() {
    return this._remainingTimeSeconds
  }
}
